if (!customElements.get('custom-plans')) {
    customElements.define(
      'custom-plans',
      class CustomPlans extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
          this.planRadios = this.querySelectorAll('input[name="custom-plan"]');
          this.sellingPlanRadio = this.querySelector('input[name="custom-plan"][data-selling-type="subscribe"]');
          this.form = this.closest('.product-form');
          this.qtyInput = this.form?.querySelector('input[name="quantity"]');
          this.sellingPlanInput = this.form?.querySelector('input[name="selling_plan"]');
  
          if (!this.qtyInput || !this.sellingPlanInput || this.planRadios.length === 0) return;
  
          this.planRadios.forEach(radio => {
            radio.addEventListener('change', this.handleChange);
          });

          const firstRadio = this.planRadios[0];
          if (firstRadio) {
            firstRadio.checked = true;
            const changeEvent = new Event('change', { bubbles: true });
            firstRadio.dispatchEvent(changeEvent);
          }
        }
  
        disconnectedCallback() {
          this.planRadios.forEach(radio => {
            radio.removeEventListener('change', this.handleChange);
          });
        }
  
        handleChange = (event) => {
          const radio = event.target;
          if (!radio.checked) return;
  
          const isSubscription = radio.dataset.sellingType === 'subscribe';
          const qty = parseInt(radio.dataset.qty || '1', 10);
  
          if (isSubscription) {
            this.qtyInput.value = 1;
            this.sellingPlanInput.disabled = false;
            this.sellingPlanInput.value = radio.dataset.sellingPlan;
          } else {
            this.qtyInput.value = qty;
            this.sellingPlanInput.disabled = true;
            this.sellingPlanInput.value = '';
          }
        };
      }
    );
  }